import React, { useEffect, useState } from "react";
import apiClient from "../../api/client";

function StatsSesgos() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get('/api/sesgos/stats')
      .then(res => setStats(res.data))
      .catch(err => console.error('Error al obtener estadísticas de sesgos:', err))
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    {
      key: 'rutas_afectadas',
      titulo: 'Rutas afectadas',
      descripcion: 'Rutas con al menos un cruce reportado sin caseta en la ruta',
      icon: 'fa-route',
      bg: '#dc3545',
    },
    {
      key: 'cruces_pendientes',
      titulo: 'Cruces pendientes',
      descripcion: 'Cruces con estatus CasetaNoEncontradaEnRuta que requieren corrección',
      icon: 'fa-unlink',
      bg: '#fd7e14',
    },
    {
      key: 'vinculos_creados',
      titulo: 'Vínculos creados',
      descripcion: 'Entradas en Cat_EntidadCaseta que mapean un nombre PASE a una caseta TUSA',
      icon: 'fa-link',
      bg: '#28a745',
    },
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-3">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <div className="row mb-4">
      {cards.map(({ key, titulo, descripcion, icon, bg }) => (
        <div key={key} className="col-xl-4 col-md-4 mb-3">
          <div className="card border-0 shadow-sm h-100" style={{ borderLeft: `4px solid ${bg}` }}>
            <div className="card-body py-3">
              <div className="d-flex align-items-center">
                <div className="mr-3" style={{ width: '42px', height: '42px', borderRadius: '50%', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className={`fas ${icon} text-white`}></i>
                </div>
                <div>
                  <div className="h4 mb-0 font-weight-bold text-gray-800">
                    {stats ? (stats[key] ?? '—').toLocaleString('es-MX') : '—'}
                  </div>
                  <div className="text-xs font-weight-bold text-uppercase mb-0" style={{ color: bg }}>{titulo}</div>
                </div>
              </div>
              <p className="small text-muted mt-2 mb-0">{descripcion}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StatsSesgos;
